import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CreditCardIcon, IdentificationIcon, UsersIcon } from '@heroicons/react/24/solid';

import TabNavigation from '../../../components/TabNavigation';
import { ClientExtraInfoModal } from '../../../components/modals/ClientExtraInfoModal';
import { selectUserInfo } from '../../../features/users/userInfoSlice';
import { usePathUrlMatcher } from '../../../utils/hooks';
import { selectorTour } from '../../../features/tour/tourSlice';

const Dashboard = ({ }) => {
  const { location } = useHistory()

  const userContext = useSelector(selectUserInfo);
  const isTourLaunched = useSelector(selectorTour)


  const tabs = [
    { title: 'Mes informations de compte', href: '/account', disabled: false, icon: <IdentificationIcon className="h-4 text-inherit mt-0.5" /> },
    { title: 'Mes utilisateurs', href: location.pathname.startsWith('/account/users/') ? location.pathname : '/account/users', disabled: !userContext?.user?.admin, icon: <UsersIcon className="h-4 text-inherit mt-0.5" /> },
    { title: 'Mon forfait', href: '/account/forfait', disabled: !userContext?.user?.admin, icon: <CreditCardIcon className="h-4 text-inherit mt-0.5" /> }
  ];

  return (
    <div className="relative pb-4">
      <TabNavigation tabs={tabs} />

      {usePathUrlMatcher()}

      {!isTourLaunched && !!localStorage.getItem(userContext?.user?.company_id) && <ClientExtraInfoModal
        data={userContext?.user?.company}
        open={!isTourLaunched && (location.pathname === tabs[0].href) && !userContext?.user?.company?.siren && userContext?.user?.admin}
      />}
    </div>
  );
};

export default Dashboard;
